import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Category.List.IRequest;
type Response = Api.Core.Category.List.IResponse;
type Headers = Api.Core.Category.List.IHeaders;
const url = '/api/Management/Category';
export default async function categoryListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
